/**
 * AIAssistant — wraps the launcher + palette.
 *
 * Mounted once in App.tsx (inside AuthProvider, outside Routes) so the
 * Cmd+K shortcut and the bottom-right pill work on every page without
 * the page needing to know about it.
 *
 * Visibility rule: ONLY staff (COORDINATOR / HOD / ADMIN, or dual-hat
 * HODs with is_internship_coordinator=true) see the launcher. Students
 * are completely unaware the assistant exists — matches the backend
 * AskView's permission check.
 */
import { useAuth } from '../../contexts/AuthContext';
import { AssistantLauncher } from './AssistantLauncher';
import { AssistantPalette } from './AssistantPalette';

export function AIAssistant() {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) return null;

  const isStaff =
    user.role === 'ADMIN' ||
    user.role === 'HOD' ||
    user.role === 'COORDINATOR' ||
    user.is_internship_coordinator === true;

  if (!isStaff) return null;

  return (
    <>
      <AssistantLauncher />
      <AssistantPalette />
    </>
  );
}
